import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCompanyLogo } from '../../../../api/hooks/useCompanyLogo';
import { PdfDownloadLinkExtended } from '../../../../components';
import { nowDate } from '../../../../config/utils/dateHelpers';
import { CustomerReportResponse } from '../../../../interfaces/reports.interface';
import { CustomerReportPdf } from './pdf/CustomerReportPdf';

interface Props {
  data: CustomerReportResponse;
}

export const CustomerReportDownloadButton = ({ data }: Props) => {
  const { t } = useTranslation();
  const { data: logo, isLoading } = useCompanyLogo(data?.params?.company?.logoUrl);

  const downloadDoc = useCallback(() => {
    if (data?.params?.company) {
      const fileName = `${data?.params?.company?.title}_${t('CUSTOMERS_REPORT.DOWNLOAD_CUSTOMER_REPORT').replaceAll(' ', '')}_${nowDate()}.pdf`;

      return (
        <PdfDownloadLinkExtended
          document={<CustomerReportPdf data={data} logo={logo} />}
          fileName={fileName}
          text={t('FORMS.DOWNLOAD_PDF')}
          isLoading={isLoading}
        />
      );
    }
  }, [data, t, logo, isLoading]);

  return <>{downloadDoc()}</>;
};
